import dynamic from "next/dynamic";
import { IconsProps, BoxIconProps } from "./types";
import styles from "./index.module.scss";
import ArrowIcon2 from "./icons/ArrowIcon2";
import ChecklistBrilink from "@/src/views/components/Icon/icons/ChecklistBrilink";

const AgenIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/AgenIcon")
);
const AktivitasIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/AktivitasIcon")
);
const ArrowPaginationIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/ArrowPaginationIcon")
);
const ArrowIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/ArrowIcon")
);
const BadgeIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/BadgeIcon")
);
const CalendarIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/CalendarIcon")
);
const ChecklistBrilinkIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/ChecklistBrilink")
);
const ChecklistIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/ChecklistIcon")
);
const CircleIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/CircleIcon")
);
const DealIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/DealIcon")
);
const EditIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/EditIcon")
);
const IncreaseBarIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/IncreaseBarIcon")
);
const PieChartIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/PieChartIcon")
);
const EyeCloseIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/EyeCloseIcon")
);
const EyeOpenIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/EyeOpenIcon")
);
const ClearIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/ClearIcon")
);
const SearchIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/SearchIcon")
);
const HomeIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/HomeIcon")
);
const UnionIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/UnionIcon")
);
const FolderIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/FolderIcon")
);
const LogoutIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/LogoutIcon")
);
const ArrowUpIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/ArrowUpIcon")
);
const SubstractIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/SubstractIcon")
);
const FullArrowIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/FullArrowIcon")
);
const WarningIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/WarningIcon")
);
const ArrowCircleIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/two_color/ArrowCircleIcon")
);
const ActionIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/three_color/ActionIcon")
);
const BankruptIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/three_color/BankruptIcon")
);
const GraphIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/three_color/GraphIcon")
);
const LoanIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/three_color/LoanIcon")
);
const MoneyIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/three_color/MoneyIcon")
);
const ScreeningIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/three_color/ScreeningIcon")
);
const RemoveIcon = dynamic(
  () => import("@/src/views/components/Icon/icons/RemoveIcon")
);

const Icon = (props: IconsProps) => {
  const elementProperty = {
    size: props.size,
    color: props.color,
    rotate: props.rotate,
  };

  if (props?.select === "agen") {
    return <AgenIcon {...elementProperty} />;
  } else if (props?.select === "action") {
    return <ActionIcon {...elementProperty} />;
  } else if (props?.select === "aktivitas") {
    return <AktivitasIcon {...elementProperty} />;
  } else if (props?.select === "arrow") {
    return <ArrowIcon {...elementProperty} />;
  } else if (props?.select === "arrow2") {
    return <ArrowIcon2 {...elementProperty} />;
  } else if (props?.select === "arrowCircle") {
    return <ArrowCircleIcon {...elementProperty} />;
  } else if (props?.select === "arrowUp") {
    return <ArrowUpIcon {...elementProperty} />;
  } else if (props?.select === "arrowPagination") {
    return <ArrowPaginationIcon {...elementProperty} />;
  } else if (props?.select === "badge") {
    return <BadgeIcon {...elementProperty} />;
  } else if (props?.select === "bankrupt") {
    return <BankruptIcon {...elementProperty} />;
  } else if (props?.select === "calendar") {
    return <CalendarIcon {...elementProperty} />;
  } else if (props?.select === "checklist") {
    return <ChecklistIcon {...elementProperty} />;
  } else if (props?.select === "checklistBrilink") {
    return <ChecklistBrilink {...elementProperty} />;
  } else if (props?.select === "clear") {
    return <ClearIcon {...elementProperty} />;
  } else if (props?.select === "deal") {
    return <DealIcon {...elementProperty} />;
  } else if (props?.select === "edit") {
    return <EditIcon {...elementProperty} />;
  } else if (props?.select === "eye_open") {
    return <EyeOpenIcon {...elementProperty} />;
  } else if (props?.select === "eye_close") {
    return <EyeCloseIcon {...elementProperty} />;
  } else if (props?.select === "folder") {
    return <FolderIcon {...elementProperty} />;
  } else if (props?.select === "fullArrow") {
    return <FullArrowIcon {...elementProperty} />;
  } else if (props?.select === "graph") {
    return <GraphIcon {...elementProperty} />;
  } else if (props?.select === "home") {
    return <HomeIcon {...elementProperty} />;
  } else if (props?.select === "increaseBar") {
    return <IncreaseBarIcon {...elementProperty} />;
  } else if (props?.select === "loan") {
    return <LoanIcon {...elementProperty} />;
  } else if (props?.select === "logout") {
    return <LogoutIcon {...elementProperty} />;
  } else if (props?.select === "money") {
    return <MoneyIcon {...elementProperty} />;
  } else if (props?.select === "pie_chart") {
    return <PieChartIcon {...elementProperty} />;
  } else if (props?.select === "screening") {
    return <ScreeningIcon {...elementProperty} />;
  } else if (props?.select === "search") {
    return <SearchIcon {...elementProperty} />;
  } else if (props?.select === "substract") {
    return <SubstractIcon {...elementProperty} />;
  } else if (props?.select === "union") {
    return <UnionIcon {...elementProperty} />;
  } else if (props?.select === "warning") {
    return <WarningIcon {...elementProperty} />;
  } else if (props?.select === "remove") {
    return <RemoveIcon {...elementProperty} />;
  }
};

Icon.defaultProps = {
  size: "12",
  color: "#F36F21",
  rotate: "0",
  select: "eye_close",
};

const Icons = (props: BoxIconProps) => {
  const iconProperty = {
    select: props.select,
    size: props.size,
    color: props.color,
    rotate: props.rotate,
  };
  return (
    <div
      className={`${styles.icons} ${styles["icons-size--" + props?.size]} ${
        styles["icons-variant--" + props?.mode]
      } ${
        props?.backgroundColor !== "none"
          ? styles["icons-background--" + props?.backgroundColor]
          : ""
      }`}
    >
      <Icon {...iconProperty} />
    </div>
  );
};

Icons.defaultProps = {
  mode: "none",
  backgroundColor: "none",
  size: "12",
  color: "#F36F21",
  rotate: "0",
  select: "eye_close",
};

export default Icons;
